import styled from 'styled-components';

const FAQSectionStyle = styled.div`
	--faqTitleDescriptionDistance: var(--sp4x);
	--collapseItemPadTB: var(--sp6x);
	--innerWrapperPatT: var(--sp5x);
	--plusMinusIconSize: var(--sp4x);

	.faq-description {
		margin-top: var(--faqTitleDescriptionDistance);
	}

	.collapse-item-wrapper {
		#collapse-item {
			border-bottom: 2px solid rgba(191, 157, 102, 0.3);
			padding: var(--collapseItemPadTB) 0;
		}

		&:nth-child(1) {
			#collapse-item {
				padding-top: 0;
			}
		}
	}

	#collapse-title {
		display: flex;
		justify-content: space-between;
		gap: var(--sp2x);
	}

	.plus-minus-icon {
		position: relative;
		overflow: hidden;
		max-width: var(--plusMinusIconSize);
		width: 100%;
		height: var(--plusMinusIconSize);

		&:after,
		&:before {
			content: '';
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			width: var(--plusMinusIconSize);
			height: 2px;
			background-color: var(--primaryColor9);
			transition: transform var(--trTime) ease-out;
		}

		&:before {
			width: 2px;
			height: var(--plusMinusIconSize);
		}
	}

	#collapse-item {
		&.active {
			.plus-minus-icon {
				&:before {
					transform: translate(-50%, -50%) rotate(90deg);
				}
			}
		}
	}

	.editor-wrapper {
		padding-top: var(--innerWrapperPatT);
	}

	.editor-wrapper {
		* {
			color: var(--primaryColor9);
		}

		blockquote {
			border-color: var(--primaryColor9);
		}

		ol li:before,
		ul li:before {
			background-color: var(--primaryColor9);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--faqTitleDescriptionDistance: var(--sp3x);
		--collapseItemPadTB: var(--sp5x);
		--innerWrapperPatT: var(--sp3x);
		--plusMinusIconSize: var(--sp4x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--faqTitleDescriptionDistance: var(--sp2x);
		--collapseItemPadTB: var(--sp4x);
		--innerWrapperPatT: var(--sp3x);
		--plusMinusIconSize: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--faqTitleDescriptionDistance: var(--sp3x);
		--collapseItemPadTB: var(--sp4x);
		--innerWrapperPatT: var(--sp3x);
		--plusMinusIconSize: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--faqTitleDescriptionDistance: var(--sp3x);
		--collapseItemPadTB: var(--sp4x);
		--innerWrapperPatT: var(--sp2x);
		--plusMinusIconSize: var(--sp3x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--faqTitleDescriptionDistance: var(--sp3x);
		--collapseItemPadTB: var(--sp3x);
		--innerWrapperPatT: var(--sp2x);
		--plusMinusIconSize: var(--sp2-5x);

		.faq-title-wrapper {
			display: flex;
			justify-content: center;
		}

		.faq-title-inner-wrapper {
			width: 48.3%;
		}

		.faq-title,
		.faq-description {
			text-align: center;
		}

		.faq-content-wrapper {
			margin-top: var(--sp5x);
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--faqTitleDescriptionDistance: var(--sp2x);
		--collapseItemPadTB: var(--sp3x);
		--innerWrapperPatT: var(--sp2x);
		--plusMinusIconSize: var(--sp2-5x);

		.faq-title-wrapper {
			display: flex;
			justify-content: center;
		}

		.faq-title-inner-wrapper {
			width: 47%;
		}

		.faq-title,
		.faq-description {
			text-align: center;
		}

		.faq-content-wrapper {
			margin-top: var(--sp5x);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--faqTitleDescriptionDistance: var(--sp2x);
		--collapseItemPadTB: var(--sp2-5x);
		--innerWrapperPatT: var(--sp2x);
		--plusMinusIconSize: var(--sp2-5x);

		.faq-title-wrapper {
			display: flex;
			justify-content: center;
		}

		.faq-title-inner-wrapper {
			width: 100%;
		}

		.faq-title,
		.faq-description {
			text-align: center;
		}

		.faq-content-wrapper {
			margin-top: var(--sp5x);
		}
	}
`;

export default FAQSectionStyle;
